import React from 'react';
import ReactDOM from 'react-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import VideoDOM_without_blob from '../videoDOM_without_blob';

import Slideshow from '../chapter2/slideshow';
import SlideshowLogin from '../chapter2/slideshow_login';

import QuizIntro from '../chapter2/quiz-intro';
import Interview_questions from '../chapter2/interview_questions';
import User_questions from '../chapter2/user_questions';
import Evaluation_questions from '../chapter2/evaluation_questions';
import ThankYouEmail from '../chapter2/thankYouEmail';

import img from '../../poster/quiz-poster.jpg';

import '../../styles/chapter2/videoStack.scss';
import '../../styles/chapter2/quiz.scss';


function GetVideo(props){
	return (<div className="video-stack">					
						<VideoDOM_without_blob 
							src={props.src}
							timeupdate={props.timeupdate}
							ended={props.ended}
							isPlaying={props.isPlaying}
							play={props.play}
							pause={props.pause}
							poster={img} />
					</div>);
}

class Quiz extends React.Component{
	constructor(props){
		super(props);

		this.state = {
			intro : true,
		}

	}

	componentDidMount(){

		//this.props.disableQuizIntro();
		this.props.getRandomQuizQuestion();
	}

	componentWillReceiveProps(nextProps){

		if(nextProps.timecode > 20 && nextProps.timecode < 30 && nextProps.question === 3){
			if(!this.state.showSlideshowLogin){
				this.setState({
					showSlideshowLogin : true
				});
			}
		}else{
			
			if(this.state.showSlideshowLogin){
				this.setState({
					showSlideshowLogin : false
				});
			}
		}
	}

	skipVideo(){
		console.log(this.videoRef.video.duration);
		this.videoRef.video.currentTime = this.videoRef.video.duration - 5;
	}

	render(){
		return (<div className="quiz-holder">

	{/* Interview Intro */}
		
	<ReactCSSTransitionGroup
		component= "div"
		className={"quiz-intro"}
		transitionName="fade"
		transitionAppear={true}
		transitionAppearTimeout={500}
		transitionEnterTimeout={500}
		transitionLeaveTimeout={300}>	
			{this.props.showIntro &&
				<QuizIntro disableQuizIntro={()=>this.props.disableQuizIntro()}/>
			}
	</ReactCSSTransitionGroup>
	



	{(this.props.showQuiz ) && 
		<div className="quiz-holder-inner">
			{/* Slideshow */}

		{/*<button className="helper top-left" onClick={()=>this.skipVideo()}>skipVideo</button>*/}

			{this.props.showSlideshowLogin && 
				<SlideshowLogin 
					success={this.props.showSlideShowAction}
					showTimeline={this.props.showTimeline}
					hideTimeline={this.props.hideTimeline}
					timelineVisible={this.props.timelineVisible} />
			}
			{this.props.showSlideshow && 
				<Slideshow hideSlideShow={this.props.hideSlideShowAction}/>
			}

			{/* User Question */}
					<ReactCSSTransitionGroup
						component= "div"
						className={"user-question-holder question-active-" + this.props.timeforUserQuiz}
						transitionName="fade"
						transitionAppear={true}
						transitionAppearTimeout={500}
						transitionEnterTimeout={500}
						transitionLeaveTimeout={300}>

							{this.props.timeforUserQuiz && 
								<User_questions 
									selectedUserQuestion = {this.props.selectedUserQuestion}
									currentQuestion={this.props.question} 
									selectQuestion={this.props.selectQuestion} 
									data={this.props.selectedQuestion}
									addUserAnswer={this.props.addUserAnswer} />
							}

					</ReactCSSTransitionGroup>

				{/* Interview Question */}
						<ReactCSSTransitionGroup
							component= "div"
							className={"interview-question-holder question-active-" + this.props.timeforInterview}
							transitionName="fade"
							transitionAppear={true}
							transitionAppearTimeout={500}
							transitionEnterTimeout={500}
							transitionLeaveTimeout={300}>		
								{this.props.timeforInterview &&
									<Interview_questions 
										currentQuestion={this.props.question} 
										selectQuestion={this.props.selectQuestion} 
										data={this.props.selectedInterviewQuestion} />
								}
						</ReactCSSTransitionGroup>
				{/* Evaluation */}
					<ReactCSSTransitionGroup
						component= "div"
						className={"evaluation-question-holder question-active-" + this.props.timeforEvaluation}
						transitionName="fade"
						transitionAppear={true}
						transitionAppearTimeout={500}
						transitionEnterTimeout={500}
						transitionLeaveTimeout={300}>		
							{this.props.timeforEvaluation && 
								<Evaluation_questions 
									evalUserAnswers={this.props.userAnswers} 
									goToSpecificQuestion={this.props.goToSpecificQuestion}
									showThankYou={this.props.showThankYou} />
							}
					</ReactCSSTransitionGroup>

				{/* Thank you email */}
					<ReactCSSTransitionGroup
						component= "div"
						className={"evaluation-question-holder question-active-" + this.props.timeforThankYou}
						transitionName="fade"
						transitionAppear={true}
						transitionAppearTimeout={500}
						transitionEnterTimeout={500}
						transitionLeaveTimeout={300}>		
							{this.props.timeforThankYou && 
								<ThankYouEmail/>
							}
					</ReactCSSTransitionGroup>
					



				{/* Video */}
					
						<ReactCSSTransitionGroup
						component= "div"
						className={"video-question-holder"}
						transitionName="fade"
						transitionAppear={true}
						transitionAppearTimeout={500}
						transitionEnterTimeout={500}
						transitionLeaveTimeout={300}>
							{this.props.selectedQuestion != false &&
								<VideoDOM_without_blob 
									ref={(video)=>{this.videoRef = video;}}
									key={this.props.selectedQuestion.video}
									src={_assets.root + "/video/chapter2/"+ _assets.videoSize + "/" + this.props.selectedQuestion.video}
									timeupdate={this.props.timeupdate}
									isWaiting={this.props.isWaiting}
									ended={this.props.ended}
									isPlaying={this.props.isPlaying}
									play={this.props.play}
									pause={this.props.pause}
									poster={img} />
							}
							
						</ReactCSSTransitionGroup>

					
			</div>
		}
		</div>);
	}
}

export default Quiz;











// WEBPACK FOOTER //
// ./src/scripts/chapter2/quiz.js